import Joyride, { type CallBackProps } from 'react-joyride';
import { joyrideLocale, joyrideStyles } from './joyrideConfig';
import { policyVersionsTourSteps } from './policyVersionsTourSteps';
import { useCompanyPolicyTour } from './useCompanyPolicyTour';

const TOUR_STORAGE_KEY = 'hr-company-policy-versions-tour-completed';

type PolicyVersionsTourProps = {
    run: boolean;
    onCallback: (data: {
        status?: string;
        type?: string;
        index?: number;
    }) => void;
};

export function PolicyVersionsTour({
    run,
    onCallback,
}: PolicyVersionsTourProps) {
    const handleCallback = (data: CallBackProps) => {
        onCallback({ status: data.status, type: data.type, index: data.index });
    };

    return (
        <Joyride
            steps={policyVersionsTourSteps}
            run={run}
            continuous
            showProgress
            showSkipButton
            callback={handleCallback}
            locale={joyrideLocale}
            styles={joyrideStyles}
            scrollToFirstStep
            scrollOffset={24}
            scrollDuration={300}
        />
    );
}

export function usePolicyVersionsTour() {
    return useCompanyPolicyTour(TOUR_STORAGE_KEY);
}
